import React from "react";
import { MdLocalShipping } from "react-icons/md";
import { CgRedo } from "react-icons/cg";

const BannerBottom = () => {
  return (
    <div className="w-full bg-white border-b-[1px] py-6 border-b-gray-200 px-6">
      <div className="max-w-container mx-auto h-24 flex flex-col md:flex-row justify-between items-center">
        
        <div className="flex items-center gap-6 w-80 shadow-sm hover:shadow-md duration-300">
          <span className="font-bold font-titleFont text-2xl w-10 text-center">2</span>
          <p className="text-lightText text-xl font-bold">Two years warranty</p>
        </div>

        
        <div className="flex md:w-auto items-center gap-6 w-80 shadow-sm hover:shadow-md duration-300">
          <span className="text-4xl text-center w-10">
            <MdLocalShipping />
          </span>
          <p className="text-lightText text-xl font-bold">Free shipping      </p>
        </div>

        
        <div className="flex md:w-auto items-center gap-6 w-80 shadow-sm hover:shadow-md duration-300">
          <span className="text-5xl text-center w-10">
            <CgRedo />
          </span>
          <p className="text-lightText text-xl font-bold">Return policy in 30 days</p>
        </div>
      </div>
    </div>
  );
};

export default BannerBottom;
